import React from 'react';
import { NavLink } from 'react-router-dom';

interface SidebarItemProps {
    icon: string;
    text: string;
    to: string;
    activeClassName?: string;
    className?: string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({icon, text, to}) => {    
    return (
        <NavLink to={to}>
            {({ isActive }) => {
                // Reemplaza la terminación 'B' por 'W' cuando está activo
                const activeIcon = icon.replace("B.png", "W.png");

                return (
                    <div className={isActive ? `flex flex-row h-12 border-y border-gray-600 font-sourceSans items-center font-bold` : 'flex flex-row h-12 border-y border-gray-400 font-sourceSans items-center'}>
                        <div className={isActive ? `bg-[#1c1c2e] rounded-r-full h-full w-12 flex items-center justify-center` : `flex flex-row items-center justify-center border-y border-gray-400 font-sourceSans w-12 h-12`}>
                            <img src={isActive ? activeIcon : icon} alt="icon" className="h-6 w-6" />
                        </div>
                        <span className="flex-grow text-center font-sourceSans">{text}</span>
                    </div>
                );
            }}
        </NavLink>
    );
}

export default SidebarItem;